/**
 * Movataa Scroll Animations
 * Uses IntersectionObserver for performant scroll-triggered reveals
 * Respects prefers-reduced-motion
 */
(function() {
  'use strict';

  // Skip if user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Auto-apply reveal class to key sections
  const selectors = [
    '.movataa-clinical',
    '.movataa-howto',
    '.movataa-free-from',
    '.movataa-product-trust',
    '.section-blockquote',
    '.section-testimonials',
    '.section-image-with-text',
    '.section-before-after',
    '.section-card-list',
    '.section-brand-image',
    '.section-image-collage',
    '[class*="multicolumn"]'
  ];

  document.addEventListener('DOMContentLoaded', function() {
    // Add reveal class to matching elements
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (!el.classList.contains('movataa-reveal')) {
          el.classList.add('movataa-reveal');
        }
      });
    });

    // Create observer
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    // Observe all reveal elements
    document.querySelectorAll('.movataa-reveal').forEach(function(el) {
      observer.observe(el);
    });

    // Lazy load image fade-in
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('loaded');
        });
      }
    });
  });
})();
